export default (loanApplicationId = null) => ({
    loanApplicationId,
    vehicleSellerConfigurationId: null,
    applicationType: null,
    vehicleCondition: null
});